import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Layout, Loading, UserNavbar } from '../../../components';
import UpcomingEvents from './components/UpcomingEvents';
import VendorProfileCard from './components/Profile/VendorProfile';
import VendorPhotos from './components/Photos';

function VendorProfile() {
  const { loading } = useSelector((store) => store.events);

  return (
    <Layout>
      {loading && <Loading />}
      <UserNavbar />
      <Grid
        container
        marginTop={9}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Grid item xs={12} lg={10}>
          <VendorProfileCard />
          <UpcomingEvents />
          <VendorPhotos />
        </Grid>
      </Grid>
    </Layout>
  );
}

export default VendorProfile;
